import {Form, FormInstance, Radio} from 'antd';

import {Text} from '../../../../../../component/text/text';
import {Locale} from '../../../../../../provider/locale/locale';
import {EditUserType} from '../../../../../../service/user-management/user-management-edit-user';
import {useUserRoles} from '../../../../../../service/user-management/user-management-user';
import {
    UserAuthTypeEnum,
    UsersFormKeyEnum,
    UsersFormType,
} from '../../../../../../service/user-management/user-management-users';

type PropsType = {
    form: FormInstance<UsersFormType>;
    user?: EditUserType;
};

// The sign-in method is chosen once, at the invitation; an existing user only shows it.
export function UsersFormAuthType(props: PropsType): JSX.Element | null {
    const {form, user} = props;

    const {data: currentUser} = useUserRoles();

    const isVisible = Boolean(currentUser?.hasSso || user?.isSso);

    if (!isVisible) {
        return null;
    }

    return (
        <Form.Item label={<Text stringKey="USERS__FORM__AUTH_TYPE__LABEL" />} name={UsersFormKeyEnum.AuthType}>
            <Radio.Group
                disabled={Boolean(user)}
                onChange={() => form.resetFields([UsersFormKeyEnum.RoleId])}
                optionType="button"
                options={[
                    {
                        label: <Locale stringKey="USERS__FORM__AUTH_TYPE__PASSWORD" />,
                        value: UserAuthTypeEnum.Password,
                    },
                    {
                        label: <Locale stringKey="USERS__FORM__AUTH_TYPE__SSO" />,
                        value: UserAuthTypeEnum.Sso,
                    },
                ]}
            />
        </Form.Item>
    );
}
